import i18n from "../i18n";

export const getStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const getLocalStorage = (key) => {
  return localStorage.getItem(key);
};

export const setlocalStorage = (key, value) => {
  return localStorage.setItem(key, value);
};

export const getTag = (status, translate = i18n.t.bind(i18n)) => {
  switch (status) {
    case "success":
      return {
        // icon: <CheckCircleOutlined />,
        name: translate("ng.financial.status.success"),
        color: "#28a745",
      };
    case "process":
      return {
        // icon: <SyncOutlined spin />,
        name: translate("ng.financial.status.processing"),
        color: "#ffc107",
      };
    case "failed":
      return {
        // icon: <ExclamationCircleOutlined />,
        name: translate("ng.financial.status.failed"),
        color: "#dc3545",
      };
    case "withdraw_failed":
      return { name: translate("ng.financial.status.failed"), color: "magenta" };
    case "withdraw_cancel":
      return { name: translate("ng.financial.status.cancelled"), color: "#dc3545" };
    case "withdraw_success":
      return { name: translate("ng.financial.status.success"), color: "#28a745" };
    case "withdraw_waiting":
      return { name: translate("ng.financial.status.waiting"), color: "gold" };
    default:
      return { name: "-", color: "" };
  }
};

export const getTagLotto = (status, translate = i18n.t.bind(i18n)) => {
  switch (status) {
    case "success":
      return { name: translate("ng.financial.status.resulted"), color: "#28a745" };
    case "cancel":
      return { name: translate("ng.financial.status.cancelled"), color: "#ff4d3b" };
    case "pending":
      return { name: translate("ng.financial.status.pendingResult"), color: "#ffc107" };
    default:
      return { name: "-", color: "" };
  }
};
